import React from 'react';
import ErrorPage from '../pages/ErrorPage';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

class NewRelicErrorBoundary extends React.Component<Props, State> {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error): void {
    window.newrelic?.noticeError?.(error);
  }

  public render(): React.ReactNode {
    const { children } = this.props;

    if (process.env.NODE_ENV === 'development') {
      return <>{children}</>;
    }

    return this.state.hasError ? <ErrorPage /> : children;
  }
}

export default NewRelicErrorBoundary;
